// Utility to map simple numeric teacher IDs to MongoDB ObjectIds
export const mapTeacherId = (id: string): string => {
  const idMap: { [key: string]: string } = {
    '1': '000000000000000000000001',
    '2': '000000000000000000000002', 
    '3': '000000000000000000000003',
    '4': '000000000000000000000004',
    '5': '000000000000000000000005'
  };
  return idMap[id] || id;
};

// Utility to map MongoDB ObjectIds back to simple numeric teacher IDs
export const unmapTeacherId = (objectId: string): string => {
  const reverseMap: { [key: string]: string } = {
    '000000000000000000000001': '1',
    '000000000000000000000002': '2',
    '000000000000000000000003': '3',
    '000000000000000000000004': '4',
    '000000000000000000000005': '5'
  };
  return reverseMap[objectId] || objectId;
};
